import React from 'react';
import { Box } from '@material-ui/core';
import { Typography } from '@orijinworks/frontend-commons';
import { useExistingPlanChipStyles } from './ExistingPlanChip.styles';

/**
 * Status chip shown for resident options that already have a plan.
 */
export const ExistingPlanChip = () => {
  const classes = useExistingPlanChipStyles();

  return (
    <Box className={classes.root}>
      <Typography className={classes.label}>Existing Plan</Typography>
    </Box>
  );
};

export default ExistingPlanChip;
